export const selectAdminUpdateToken = (state) => state.adminUpdate.token;
export const selectAdminUpdateInitiated = (state) =>
  state.adminUpdate.adminUpdateLicenseInitiated;
export const selectAdminUpdateApplicationNumber = (state) =>
  state.adminUpdate.applicationNumber;
export const selectAdminUpdatedPermitData = (state) =>
  state.adminUpdate?.permitData;
export const selectAdminUpdateLicenseInProgress = (state) =>
  state.adminUpdate.adminUpdateLicenseInProgress;
export const selectAdminUpdateLicenseError = (state) =>
  state.adminUpdate.adminUpdateLicenseError;
export const selectAdminDocumentUploadError = (state) =>
  state.adminUpdate?.documentUploadError;
export const selectPermitRegistrant = (state) =>
  state.adminUpdate?.permitData?.registrant;
export const selectAdminUpdateLicenseNumber = (state) =>
  state.adminUpdate?.licenseNumber;
export const selectFetchedRegistrantDetails = (state) =>
  state.adminUpdate?.fetchedRegistrantDetails ?? false;
